import {
  CLEAR_FILTERS_MARKET_CYCLE,
  DISPLAY_BIG_NUMBERS_MARKET_CYCLE,
  SET_MARKET_CYCLE_TIMEFRAME,
  UPDATE_CHARTS_DATA_MARKET_CYCLE,
  UPDATE_MARKET_CYCLE_FILTERS,
  UPDATE_MARKET_CYCLE_FILTERS_INPUT_INTERVALS,
  UPDATE_REQUEST_STATUS_MARKET_CYCLE,
} from './marketCycle.actions';

const marketCycleFiltersOptions = {
  realtyTypes: [
    { name: 'Apartamento', id: 'ap' },
    { name: 'Casa', id: 'cs' },
    { name: 'Comercial', id: 'comm' },
  ],
  timeframe: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  privateAreaInterval: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  valueInterval: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  unitPrice: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  realtyAge: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  bedrooms: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  suites: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  garages: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    {
      name: '2',
      selected: false,
    },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
};

const initialFiltersMarketCycle = {
  realtyType: { name: 'Apartamento', id: 'ap' },
  inputIntervals: {
    timeframe: { min: '', max: '' },
    privateAreaInterval: { min: '', max: '' },
    pricePerSquareMt: { min: '', max: '' },
    unitPrice: { min: '', max: '' },
    realtyAge: { min: '', max: '' },
  },
  bedrooms: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  suites: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    { name: '2', selected: false },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
  garages: [
    { name: '0', selected: false },
    { name: '1', selected: false },
    {
      name: '2',
      selected: false,
    },
    { name: '3', selected: false },
    { name: '4+', selected: false },
  ],
};

const initialState = {
  marketCycleFiltersOptions,
  marketCycleFilters: JSON.parse(JSON.stringify(initialFiltersMarketCycle)),
  requesStatusMarketCycle: {
    // INACTIVE | LOADING | LOADED | FAILED
    selicRate: 'INACTIVE',
    releasesINCC: 'INACTIVE',
    secondaryINCC: 'INACTIVE',
    releasesVersusIPCA: 'INACTIVE',
    realEstateFinancing: 'INACTIVE',
    releasesRealEstateFinancing: 'INACTIVE',
  },
  marketCycleTimeframe: ['2022'],
  chartsDataMarketCycle: {
    releasesRealEstateFinancing: [],
    releasesINCC: [],
    releasesRealEstateFinancing: [],
    releasesVersusIPCA: [],
    secondaryINCC: [],
    selicRate: [],
  },
};

export default function marketCycleReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case UPDATE_MARKET_CYCLE_FILTERS:
      return {
        ...state,
        marketCycleFilters: {
          ...state.marketCycleFilters,
          [payload.name]: payload.value,
        },
      };
    case UPDATE_MARKET_CYCLE_FILTERS_INPUT_INTERVALS:
      return {
        ...state,
        marketCycleFilters: {
          ...state.marketCycleFilters,
          inputIntervals: {
            ...state.marketCycleFilters.inputIntervals,
            [payload.name]: payload.value,
          },
        },
      };
    case CLEAR_FILTERS_MARKET_CYCLE:
      return {
        ...state,
        marketCycleFilters: initialFiltersMarketCycle,
      };
    case UPDATE_REQUEST_STATUS_MARKET_CYCLE:
      return {
        ...state,
        requesStatusMarketCycle: {
          ...state.requesStatusMarketCycle,
          [payload.name]: payload.value,
        },
      };
    case SET_MARKET_CYCLE_TIMEFRAME:
      return { ...state, marketCycleTimeframe: payload };
    case UPDATE_CHARTS_DATA_MARKET_CYCLE:
      return {
        ...state,
        chartsDataMarketCycle: {
          ...state.chartsDataMarketCycle,
          [payload.name]: payload.value,
        },
      };
    default:
      return state;
  }
}
